import { isString } from '@immutabl3/utils';

export default function generateMeshPreset({
  nodes,
  materials,
  geometry: defaultGeometry = '',
  material: defaultMaterial = 'default',
}) {
  return ({
    name,
    geometry = defaultGeometry,
    material = defaultMaterial,
    position,
    rotation,
    scale,
  }, idx) => (
    <mesh
      key={ idx }
      name={ name }
      position={ position }
      rotation={ rotation }
      scale={ scale }
      geometry={ isString(geometry) ? nodes[geometry].geometry : geometry }
      material={ isString(material) ? materials[material] : material }
    />
  );
};